import { capitalize, statusColor } from '../configUtils';

/*
 * Employer detail header — fill-in-the-blanks config.
 *
 * Employer records key their fields as empCompanyName/empWebsite/… (not the
 * generic name/title/companyName the header falls back to), so without this
 * config the header showed a blank title ('-') for every employer. See
 * headerConfig.js's genericBuildData for the fallback this overrides.
 *
 *   title    : fields joined together to form the heading
 *   eyebrow  : small line shown above the title
 *   status   : the coloured status pill
 *   ids      : id chips shown under the title  → { label, field }
 *   meta     : the icon + text row             → { icon, field }
 *   timestamp: the date line under the header
 */
export const employerConfig = {
  module: 'employer',
  header: {
    title: 'empCompanyName',
    eyebrow: 'empWebsite',

    status: ({ val, has }) => (
      has(val('status'))
        ? { label: capitalize(val('status')), color: statusColor(val('status')) }
        : null
    ),

    ids: [
      { label: 'Federal Tax ID', field: 'empFederalTaxId' },
      { label: 'State of Incorporation', field: 'empStateOfIncorporation' },
    ],

    meta: [
      { icon: 'location', field: 'empCompanyLocation' },
    ],

    timestamp: { label: 'Created Date', field: ['createdAt', 'createdDate'] },
  },
};

export default employerConfig;
